import React, { MouseEventHandler } from 'react';
import {
  PaperProps,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Paper,
} from '@material-ui/core';

export type NavigationAlertDialogProps = {
  open?: boolean;
  onClose?: MouseEventHandler;
  onConfirm?: MouseEventHandler;
  labeledBy?: string;
  describedBy?: string;
};

const NavigationAlertDialog = ({
  open = false,
  onClose = () => undefined,
  onConfirm = () => undefined,
  labeledBy = 'default-label',
  describedBy = 'default-description',
}: NavigationAlertDialogProps): JSX.Element => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby={labeledBy}
      aria-describedby={describedBy}
      PaperComponent={(props: PaperProps) => <Paper {...props} data-testid="alert-dialog" />}
    >
      <DialogTitle id={labeledBy} data-testid="alert-dialog-title">
        ARE YOU SURE?
      </DialogTitle>
      <DialogContent>
        <DialogContentText id={describedBy} data-testid="alert-dialog-description">
          Are you sure you want to leave this screen? You will lose unsaved changes.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="text" onClick={onClose} color="primary" aria-label="cancel-action" data-testid="cancel-action">
          Cancel
        </Button>
        <Button
          variant="text"
          onClick={onConfirm}
          color="primary"
          autoFocus
          aria-label="confirm-action"
          data-testid="confirm-action"
        >
          Leave
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NavigationAlertDialog;
